
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/[feature]",
      function () {
        return require("private-next-pages/features/[feature].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/[feature]"])
      });
    }
  